var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bank-card-block"},[_c('div',{staticClass:"bank-card-block__img",class:{
        'paypal' : _vm.type==='paypal',
        'mastercard' : _vm.type==='mastercard',
        'visa' : _vm.type==='visa',
      }})])
}
var staticRenderFns = []

export { render, staticRenderFns }